module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"placeholder":"请写评论","submit":"注册","cancel":"取消","create_comment_failure":"评论发布时发生错误。","edit_comment_failure":"评论编辑时发生错误。","confirm_cancel_edit":"确定要取消评论修改吗？"}}')
  delete Component.options._Ctor
}
